module.exports = __webpack_public_path__ + "img/paint-ia.1b44fc57.svg";